import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

import { Badge } from "components/ui/badge";
import { BlockUserModal } from "@/modules/users/components/block-user-modal";
import { Button } from "@/components/ui/button";
import { ColumnDef } from "@tanstack/react-table";
import { DotsHorizontalIcon } from "@/components/icons/dot-icon";
import { SortUser } from "../users-table/sort-user";
import { User } from "../../users.type";
import { UserAlertDialogue } from "../user-alert-dialogue";

interface UserColumnsProps {
  onEdit: (user: User) => void;
  onRefetch?: () => void;
}

export const userColumns = ({
  onEdit,
  onRefetch,
}: UserColumnsProps): ColumnDef<User & { citiesDisplay?: string[] }>[] => [
  {
    id: "name",
    accessorKey: "name",
    header: ({ column }) => SortUser("Nom", column),
    cell: ({ row }) => {
      const user = row.original;
      return (
        <div className="flex items-center gap-3">
          <div className="flex flex-col bg-transparent border-none p-0 text-left">
            <span className="font-semibold text-xs">{user.name}</span>
            <span className="text-xs text-gray-500">{user.email}</span>
          </div>
        </div>
      );
    },
  },
  {
    id: "roles",
    accessorKey: "roles",
    header: ({ column }) => SortUser("Role", column),
    cell: ({ row }) => row.original.roles.join(", "),
  },
  {
    id: "lastLoginAt",
    accessorKey: "lastLoginAt",
    header: ({ column }) => SortUser("Last login", column),
    cell: ({ row }) => row.original.lastLoginAt ?? "-",
  },
  {
    id: "citiesDisplay",
    accessorKey: "citiesDisplay",
    enableSorting: false,
    header: () => <span>Ville</span>,
    cell: ({ row }) => row.original.citiesDisplay?.join(", ") ?? "-",
  },
  {
    id: "blocked",
    accessorKey: "blocked",
    header: ({ column }) => SortUser("Statut", column),
    cell: ({ row }) => {
      const isBlocked = row.original.blocked ?? false;
      return isBlocked ? (
        <Badge className="bg-red-600 text-white border-transparent">Bloqué</Badge>
      ) : (
        <Badge className="bg-green-600 text-white border-transparent">Activé</Badge>
      );
    },
  },
  {
    id: "actions",
    enableSorting: false,
    header: () => <div className="text-left ">Action</div>,
    cell: ({ row }) => {
      return (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant="outline"
              className="flex size-8 text-muted-foreground data-[state=open]:bg-muted"
              size="icon"
            >
              <span className="sr-only">Open menu</span>
              <DotsHorizontalIcon className="h-4 w-4 text-muted-foreground" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem onClick={() => onEdit(row.original)} className="cursor-pointer">
              Edit
            </DropdownMenuItem>
            <DropdownMenuItem className="cursor-pointer" onSelect={(e) => e.preventDefault()}>
              <BlockUserModal user={row.original} onRefetch={onRefetch} />
            </DropdownMenuItem>
            <DropdownMenuItem className="cursor-pointer" onSelect={(e) => e.preventDefault()}>
              <UserAlertDialogue userId={row.original.id} />
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      );
    },
  },
];
